const SOUND_URL = `${process.env.PUBLIC_URL || ''}/sounds/notification.mp3`;
const MIN_GAP_MS = 3000;

let audio = null;
let lastPlayedAt = 0;

const getAudio = () => {
  if (!audio) {
    audio = new Audio(SOUND_URL);
    audio.preload = 'auto';
  }
  return audio;
};

export const preloadNotificationSound = () => {
  getAudio();
};

export const playNotificationSound = () => {
  const now = Date.now();
  if (now - lastPlayedAt < MIN_GAP_MS) return;
  lastPlayedAt = now;

  const el = getAudio();
  el.currentTime = 0;
  el.play().catch((err) => {
    console.warn('[notification sound] playback blocked:', err.name);
  });
};
